module.exports = __webpack_public_path__ + "static/media/overpass-bold-italic.ad84fcd4.eot";